import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";
import { Activity, AlertTriangle, Settings, Shield } from "lucide-react";
import React from "react";

interface NetworkHealthSummaryProps {
  data: any;
}

export const NetworkHealthSummary: React.FC<NetworkHealthSummaryProps> = ({
  data,
}) => {
  const cards = [
    {
      title: "Network Condition Index",
      displayValue: `${data?.overview?.networkHealthIndex?.value}`,
      tooltip:
        "A single, comprehensive score representing the overall health of the network, combining physical condition, operational performance, and compliance.",
      trendSummary: "+3.2% from last month",
      icon: <Activity className="h-8 w-8 text-blue-600" />,
    },
    {
      title: "Total Assets in Network",
      displayValue: `${data?.overview?.totalAssets?.value}`,
      tooltip:
        "The total number of individual assets (pipes, valves, meters, etc.) that make up this network.",
      trendSummary: "+2 from last quarter",
      icon: <Settings className="h-8 w-8 text-green-600" />,
    },
    {
      title: "Network Availability",
      displayValue: `${data?.overview?.networkAvailability?.value}`,
      tooltip:
        "The percentage of time the network has been operational and available to provide service as scheduled.",
      trendSummary: "+0.3% from last month",
      icon: <Shield className="h-8 w-8 text-purple-600" />,
    },
    {
      title: "Out of Service Assets",
      displayValue: `${data?.overview?.outOfServiceAssets?.value}`,
      tooltip:
        "The number of assets within this network that are currently in a non-operational state due to failure or maintenance.",
      trendSummary: "+1 from last week",
      icon: <AlertTriangle className="h-8 w-8 text-orange-600" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, idx) => (
        <div key={idx}>
          <QuickStatsCard {...card} />
        </div>
      ))}
    </div>
  );
};
